<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-communication">
            <div class="communication-header">
              <h3 class="title">
                <div class="item">
                  {{ $t('ho101.home') }}
                </div>
              </h3>
            </div>
            <div class="communication-total">
              <div class="header">
                <ul class="list">
                  <li class="total">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.totalApl') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.setupCount + clubAplData.aplStatsClub.idleCount}}
                      </div>
                    </div>
                  </li>
                  <li class="management">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.serviceOperating') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.setupCount}}
                      </div>
                    </div>
                  </li>
                  <li class="waiting">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.serviceIdle') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.idleCount}}
                      </div>
                    </div>
                  </li>
                  <li class="apl">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.aplCommError') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.errorCount}}
                      </div>
                    </div>
                  </li>
                  <li class="pin">
                    <div class="contain">
                      <div class="title">
                        APL Down
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.inactiveCount}}
                      </div>
                    </div>
                  </li>
                  <li class="battery">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.lowBattery') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.lowBattery}}
                      </div>
                    </div>
                  </li>
                  <li class="batteryOut">
                    <div class="contain">
                      <div class="title">
                        {{ $t('ho101.batteryOut') }}
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.outBattery}}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="main-green">
            <div class="green-map">
              <!-- 낙구 확설(Class) : falling -->
              <div class="box">
                <div class="content" >
                  <div class="pin">
                    <google-map
                      :center="googleMap.center"
                      :zoom="googleMap.zoom"
                      @load="onLoad"
                      style="width:100%; height:100%;"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="green-status">
              <div class="header">
                <h4 class="title">
                  {{ $t('ho101.currentGreenTemp') }}
                </h4>
                <div class="caption">
                  {{ $t('ho101.lastUpdated') }}
                </div>
                <div class="content">
                  <div class="contain">
                    <div class="date">
                      {{clubAplData.aplStatsHole.tempInfo.lastUpdateAt | formatDateTime}}
                    </div>
                    <div class="refresh" @click="setData">
                      <div class="item">
                        {{ $t('ho101.refresh') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body">
                <ul class="list">
                  <!-- 영하(0℃ 미만)(Class) : subzero -->
                  <li class="average" :class="clubAplData.aplStatsHole.tempInfo.averageTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      {{ $t('ho101.averageTemp') }}
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.averageTemp.temp) + '%' }">
                          {{ $t('ho101.tempStatus') }}
                        </div>
                      </div>
                    </div>
                    <!-- 온도 증감 : increase / 온도 감소 : decrease -->
                    <!--<div class="caption increase">
                      1℃
                    </div>-->
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.averageTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                  <!-- 영하(0℃ 미만) : subzero -->
                  <li class="maximum" :class="clubAplData.aplStatsHole.tempInfo.higherTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      {{ $t('ho101.maxTemp') }}
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.higherTemp.temp) + '%' }">
                          {{ $t('ho101.tempStatus') }}
                        </div>
                      </div>
                    </div>
                    <div class="caption">
                      {{getCourseData(clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx).name}} Hole {{clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx == null ? '' : viewHoleNo(clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx)}}
                    </div>
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.higherTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                  <!-- 영하(0℃ 미만) : subzero -->
                  <li class="minimum" :class="clubAplData.aplStatsHole.tempInfo.lowerTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      {{ $t('ho101.minTemp') }}
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.lowerTemp.temp) + '%' }">
                          {{ $t('ho101.tempStatus') }}
                        </div>
                      </div>
                    </div>
                    <div class="caption">
                      {{getCourseData(clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx).name}} Hole {{clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx == null ? '' : viewHoleNo(clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx)}}
                    </div>
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.lowerTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="green-board scroll-body">
              <!-- 데이터 없을때(Class) : none -->
              <div class="body dev_headerLine" :class="clubAplData.aplStatsHole.holeList.length === 0 ? 'none' : ''">
                <div class="table thead">
                  <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                  <div class="fixed grid">
                    <div class="contain">
                      <table>
                        <colgroup>
                          <col class="course">
                          <col class="hole">
                          <col class="temperature">
                          <col class="communication">
                          <col class="battery">
                        </colgroup>
                        <thead>
                        <tr>
                          <th class="course">
                            <div class="item">
                              {{ $t('common.course') }}
                            </div>
                          </th>
                          <th class="hole">
                            <div class="item">
                              {{ $t('common.hole') }}
                            </div>
                          </th>
                          <th class="aplId">
                            <div class="item">
                              APL ID
                            </div>
                          </th>
                          <th class="temperature">
                            <div class="item">
                              {{ $t('ho101.temperature') }}
                            </div>
                          </th>
                          <th class="communication">
                            <div class="item">
                              {{ $t('ho101.report') }}
                            </div>
                          </th>
                          <th class="battery">
                            <div class="item">
                              {{ $t('ho101.battery') }}
                            </div>
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="table tbody">
                  <div class="contain">
                    <table>
                      <colgroup>
                        <col class="course">
                        <col class="hole">
                        <col class="aplId">
                        <col class="temperature">
                        <col class="communication">
                        <col class="battery">
                      </colgroup>
                      <tbody>
                      <tr v-for="holeInfo in clubAplData.aplStatsHole.holeList" :key="holeInfo.hlidx">
                        <td class="course" :rowspan="getCourseData(holeInfo.hlidx).endIdx - getCourseData(holeInfo.hlidx).startIdx" v-if="getCourseData(holeInfo.hlidx).startIdx == holeInfo.hlidx">
                          {{getCourseData(holeInfo.hlidx).name}}
                        </td>
                        <td class="hole">
                          Hole {{viewHoleNo(holeInfo.hlidx)}}
                        </td>
                        <td class="aplId">
                          {{holeInfo.aplId}}
                        </td>
                        <td class="temperature">
                          {{holeInfo.temp == null ? '-' : holeInfo.temp}}{{holeInfo.temp == null ? '' : '℃'}}
                        </td>
                        <td :class="holeInfo.isActive == false ? 'communicationAbnormal' : 'communication'">
                          {{holeInfo.isActive == false ? 'Error' : $t('ho101.normal')}}
                        </td>
                        <td v-if="holeInfo.isActive == true" :class="holeInfo.lowBattery == true ? 'batteryAbnormal' : 'battery'">
                          {{holeInfo.lowBattery == true ? $t('ho101.needCharge') : $t('ho101.normal')}}({{holeInfo.battery == null ? '-' : holeInfo.battery}}{{holeInfo.battery == null ? '' : '%'}})
                        </td>
                        <td v-if="holeInfo.isActive == false" class="battery">
                          -
                        </td>
                      </tr>
                      </tbody>
                      <tbody class="none">
                      <tr>
                        <td colspan="8">
                          {{ $t('ho101.noData') }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <mainBoardPopup></mainBoardPopup>
      <footerLayout></footerLayout>
      <introLayout></introLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import FooterLayout from '../layout/Footer.vue'
import HeaderLayout from '../layout/Header.vue'
import IntroLayout from '../layout/Intro.vue'
import LeftLayout from '../layout/Left.vue'

/* Popup */
import MainBoardPopup from '../popup/MainBoard.vue'

import GoogleMap from '../common/GoogleMap.vue'

import { homeService, userService } from '../../router'

export default {
  name: 'HO101',
  data () {
    return {
      googleMap: {
        markers: [],
        markerLabels: [],
        center: {
          lat: null,
          lng: null
        },
        zoom: 16,
        map: null // 지도 객체. 지도가 로드되면 할당됨.
      },
      selectedHlidx: null,
      holeListByCourseId: [],
      clubAplData: {
        clubInfo: {
          name: ''
        },
        aplStatsClub: {
          setupCount: 0,
          idleCount: 0,
          inactiveCount: 0,
          lowBattery: 0
        },
        aplStatsHole: {
          tempInfo: {
            averageTemp: {
              temp: null
            },
            higherTemp: {
              temp: null,
              hlidx: null
            },
            lowerTemp: {
              temp: null,
              hlidx: null
            }
          },
          issueList: [],
          holeList: [],
          lastUpdateAt: null
        },
        clubInfoCourse: []
      }

    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    IntroLayout,
    MainBoardPopup,
    GoogleMap
  },
  mounted: async function () {
    const { data } = await userService.getAll()
    this.userInfo = data

    if (this.userInfo.userRole === 'ClubManager') {
      this.currentClubCode = this.userInfo.ccode
      this.setData()
    } else {
      if (this.$route.query.ccode === '') {
        this.currentClubCode = this.clubInfoList[0].ccode
      } else {
        this.currentClubCode = this.$route.query.ccode
      }
      this.setClubInfo()
      this.setData()
    }
  },
  methods: {
    onLoad (map) {
      this.googleMap.map = map
    },
    renderMapData () {
      if (!this.googleMap.map) {
        setTimeout(() => this.renderMapData(), 200)
        return
      }

      this.googleMap.markers.forEach(marker => marker.setMap(null))
      this.googleMap.markerLabels.forEach(label => label.setMap(null))
      this.googleMap.markers = []
      this.googleMap.markerLabels = []

      this.googleMap.center.lat = this.clubAplData.clubInfo.lat
      this.googleMap.center.lng = this.clubAplData.clubInfo.lon

      let leftTop = {
        lat: this.clubAplData.clubInfo.lat + this.clubAplData.clubInfo.halfLat,
        lng: this.clubAplData.clubInfo.lon - this.clubAplData.clubInfo.halfLon
      }
      let rightBottom = {
        lat: this.clubAplData.clubInfo.lat - this.clubAplData.clubInfo.halfLat,
        lng: this.clubAplData.clubInfo.lon + this.clubAplData.clubInfo.halfLon
      }

      let bounds = this.googleMap.map.createBounds()
      this.googleMap.map.extendBounds(bounds, leftTop.lat, leftTop.lng)
      this.googleMap.map.extendBounds(bounds, rightBottom.lat, rightBottom.lng)
      this.googleMap.map.fitBounds(bounds)

      for (let i in this.clubAplData.aplStatsHole.holeList) {
        let lat = this.clubAplData.aplStatsHole.holeList[i].lat
        let lng = this.clubAplData.aplStatsHole.holeList[i].lon
        let aplId = this.clubAplData.aplStatsHole.holeList[i].aplId
        let isActive = this.clubAplData.aplStatsHole.holeList[i].isActive
        let lowBattery = this.clubAplData.aplStatsHole.holeList[i].lowBattery

        let marker = this.googleMap.map.createMarker({
          lat,
          lng,
          iconUrl: 'static/assets/images/content/pc/pin-type01.png',
          width: 20,
          height: 33,
          clickable: true,
          data: this.clubAplData.aplStatsHole.holeList[i],
          onClick: function () {
            console.log(aplId)
          }
        })

        let color = '#000000'

        if (!isActive) {
          color = '#d0202e'
        } else if (lowBattery) {
          color = '#2063d2'
        }

        let markerLabel = this.googleMap.map.createLabel({
          lat,
          lng,
          content: `<div style="background-color:#FFFFFF; color:${color}; text-align:center; padding:3px 5px 3px 5px; margin-top:-60px; border-radius:40%;">` + aplId + `</div>`
        })

        this.googleMap.markers.push(marker)
        this.googleMap.markerLabels.push(markerLabel)
      }
    },
    getCourseData: function (hlidx) {
      let courseData = {}
      if (hlidx != null) {
        for (let i = 0; i < this.clubAplData.clubInfoCourse.length; i++) {
          if ((this.clubAplData.clubInfoCourse[i].startIdx <= hlidx) && (this.clubAplData.clubInfoCourse[i].endIdx > hlidx)) {
            courseData = this.clubAplData.clubInfoCourse[i]
          }
        }
      }
      return courseData
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    setData: function () {
      homeService.getClubAplData(this.currentClubCode).then(response => {
        this.clubAplData = response.data
        this.clubAplData.aplStatsHole.holeList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
        setTimeout(
          e => {
            this.renderMapData()
          },
          200
        )
      }).catch(error => {
        console.log('getClubAplData.err.===>', error)
      })
    },
    getTempGraphHeight: function (temp) {
      let tempHeight = 0
      if (temp < 0) {
        tempHeight = (100 * Math.abs(temp)) / 15
      } else {
        tempHeight = (100 * Math.abs(temp)) / 35
      }
      return tempHeight
    },
    moveHoleDetail: function (hlidx) {
      this.moveMenu(`/GR001?ccode=${this.currentClubCode}&courseId=${this.getCourseData(hlidx).courseId}&hlidx=${hlidx}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/HO101.vue